import React from 'react'
import { observer, inject } from 'mobx-react'

import { STATIC_ATTRIBUTES } from '@client/components/blocks/Text/plugins/constants'
import { ITEM_TYPE_CONFIRMATION_MAIL } from '@client/components/Editor/settings'

import './styles.scss'

const VIEW_IN_BROWSER_MARKUP = `##${STATIC_ATTRIBUTES[0].code}##`
const UNSUBSCRIBE_MARKUP = `##${STATIC_ATTRIBUTES[1].code}##`
const CONFIRM_MARKUP = `##${STATIC_ATTRIBUTES[6].code}##`

function getMessage(editor, app) {
  const viewOnlineIsMissing = editor.missingAttrs.includes(
    VIEW_IN_BROWSER_MARKUP
  )
  const unsubscribeIsMissing = editor.missingAttrs.includes(UNSUBSCRIBE_MARKUP)
  const confirmIsMissing = editor.missingAttrs.includes(CONFIRM_MARKUP)
  const bothLinksAreMissing = viewOnlineIsMissing && unsubscribeIsMissing
  const notMissingLinks = !editor.missingAttrs.length

  if (notMissingLinks) {
    return ''
  }

  if (
    confirmIsMissing &&
    editor.itemHash &&
    editor.kind === ITEM_TYPE_CONFIRMATION_MAIL
  ) {
    return app.formatMessage('requiredLinks.confirmLinkDoesNotExist')
  }
  if (!editor.itemHash) {
    if (bothLinksAreMissing) {
      return app.formatMessage('requiredLinks.requiredLinksAreNotExist')
    } else if (viewOnlineIsMissing) {
      return app.formatMessage('requiredLinks.viewOnlineLinkDosNotExist')
    } else if (unsubscribeIsMissing) {
      return app.formatMessage('requiredLinks.unsubscribeLinkDoesNotExist')
    }
  }
}

export const RequiredLinksWarning = ({ app, editor }) => {
  const message = getMessage(editor, app)

  return (
    <div className={`required-links-warning${message ? ' show' : ''}`}>
      <div>
        <span className="required-links-warning--message">{message}</span>
      </div>
      {!editor.itemHash && (
        <div>
          <a
            role="button"
            href={`https://support.getanewsletter.com${app.formatMessage(
              'requiredLinks.helpLink'
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            type="button"
            className="required-links-warning--btn bp6-button bp6-intent-danger bp6-icon-help"
          >
            {app.formatMessage('requiredLinks.needHelp')}
          </a>
        </div>
      )}
    </div>
  )
}

export default inject('app', 'editor')(observer(RequiredLinksWarning))
